import $script from 'scriptjs';

function selectText(element) {
  if (document.body.createTextRange) { // ms
    const range = document.body.createTextRange();
    range.moveToElementText(element);
    range.select();
  } else if (window.getSelection) { // moz, opera, webkit
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(element);
    selection.removeAllRanges();
    selection.addRange(range);
  }

  if (navigator.clipboard.writeText) {
    navigator.clipboard.writeText(element.innerText);
  }
}

function initializeQRCode(element) {
  new window.QRCode(element, {
    text: element.dataset.giftCardQrCode,
    width: 120,
    height: 120,
  });
}

export default class StaticGiftCard {
  constructor(section) {
    const scripts = document.querySelector('[data-scripts]');

    const cardCodeEl = section.el.querySelector('[data-gift-card-code]');
    const qrCodeEl = section.el.querySelector('[data-gift-card-qr-code]');

    if (cardCodeEl) {
      cardCodeEl.addEventListener('click', () => selectText(cardCodeEl));
    }

    if (qrCodeEl) {
      $script([scripts.dataset.qrCodeJsUrl], () => initializeQRCode(qrCodeEl));
    }
  }
}
